/**
 * Access-error classification for router guards (MYAC-758).
 *
 * When a guard fails to load a resource, we must land the user on a *clean,
 * distinct* page rather than a bare "404" for everything or a stuck navigation:
 *  - a Firestore `permission-denied` → the resource exists but is forbidden →
 *    the access-denied page (`/denied`);
 *  - anything else (missing doc, unknown) → the not-found page (`/404`).
 */

/** True when `error` is a Firestore/Firebase permission-denied error. */
export function isPermissionDenied(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const code = (error as { code?: unknown }).code
  // Firestore Web SDK uses the string code 'permission-denied'; some transports
  // surface the gRPC status 7. Match both.
  return code === 'permission-denied' || code === 7
}

/**
 * Route name to send a failed resource access to: the access-denied page for a
 * permission error, otherwise the generic not-found page.
 */
export function accessErrorRouteName(error: unknown): 'denied' | '404' {
  return isPermissionDenied(error) ? 'denied' : '404'
}
